<div style="text-align: center;">
  <img src="assets/images/dicea/Logo_horizontal_Dicea_01.jpg" alt="Logo dicea" width="300" />
  <br>
  <br>
  <h6>¡Bienvenido de nuevo! Inicia sesión para continuar.</h6>
  <br>
</div>

<form [formGroup]="loginForm" (ngSubmit)="loguearse()">
  <div class="row">
    <div class="col">

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Usuario</mat-label>
        <input type="text" maxlength="50" matInput placeholder="Ingrese usuario" formControlName="Usuario">
        <!-- <mat-error *ngIf="f.Usuario.errors?.required">Ingrese nombre de usuario.</mat-error>
        <mat-error *ngIf="f.Usuario.errors?.maxlength">Superó el máximo de caracteres.</mat-error> -->
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Contraseña</mat-label>
        <input type="password" maxlength="50" matInput placeholder="Ingrese contraseña" formControlName="Clave">
        <!-- <mat-error *ngIf="f.Clave.errors?.required">Ingrese una contraseña.</mat-error>
        <mat-error *ngIf="f.Clave.errors?.maxlength">Superó el máximo de caracteres.</mat-error> -->
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <button mat-raised-button type="submit" [disabled]="!loginForm.valid" color="primary" class="btn-submit">
        <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        Ingresar
      </button>
    </div>
  </div>
</form>
<br>
<br>
<span>¿Olvidaste tu contraseña?</span>
  <button mat-button color="accent" [routerLink]="['/restablecerContrasena']">Recuperar</button>
